import {Navigate} from 'react-router-dom'
import {ForgotPasswordForm, useAuthStore} from '@/features/auth'
import {AppHeader} from '@/widgets/app-header'
import {cn} from '@/shared/lib'

const cardClassName = cn(
  'rounded-[20px] border border-primary/15 bg-card/80 p-6 sm:p-8',
  'backdrop-blur-[20px] transition-all duration-300',
  'shadow-(--shadow-card)',
)

export function ForgotPasswordPage() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)
  if (isAuthenticated) return <Navigate to="/" replace />

  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden">
      <AppHeader />
      <div className="relative flex flex-1 items-center justify-center px-4 py-8 sm:px-8 sm:py-0">
        <div className="w-full max-w-[360px] animate-in fade-in slide-in-from-bottom-3 duration-500">
          <div className={cardClassName}>
            <h1 className="mb-6 text-xl font-semibold">Сброс пароля</h1>
            <ForgotPasswordForm />
          </div>
        </div>
      </div>
    </div>
  )
}
